
        var result = require("!!../../../../node_modules/css-loader/index.js!./event-date.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/event-date/event-date.component.css
// module id = 1412
// module chunks = 0